import { render } from "./NotificationFeature.vue?vue&type=template&id=cc0cfb72&ts=true"
import script from "./NotificationFeature.vue?vue&type=script&lang=ts"
export * from "./NotificationFeature.vue?vue&type=script&lang=ts"

import "./NotificationFeature.vue?vue&type=style&index=0&id=cc0cfb72&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__